export const USER_CONNECTED_DEVICE_CAMPAIGN_MODES = Object.freeze({
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
} as const); // Immutability while narrowing values
